"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApHeaderDropdown = void 0;
var React = require("react");
var ApMenu_1 = require("../ApMenu");
var ApHeaderDropdownLabel_1 = require("./ApHeaderDropdownLabel");
var ApHeaderDropdown_styles_1 = require("./ApHeaderDropdown.styles");
exports.ApHeaderDropdown = function (_a) {
    var options = _a.options, selected = _a.selected, onChange = _a.onChange;
    return (React.createElement(ApMenu_1.ApMenu, { placement: "bottom", button: React.createElement(ApHeaderDropdownLabel_1.default, null, selected.label) }, options.map(function (option) { return (React.createElement(ApHeaderDropdown_styles_1.ApMenuItemStyled, { key: option.label + "-" + option.value, onClick: function () {
            onChange(option);
        }, icon: React.createElement(ApHeaderDropdown_styles_1.CheckIcon, { iconName: "outline_done", visible: selected.value === option.value }) },
        React.createElement("div", null, option.label))); })));
};
exports.default = exports.ApHeaderDropdown;
//# sourceMappingURL=ApHeaderDropdown.js.map